// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Poppins&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ngb-alert {

  background-color: rgba(226, 214, 37, 0.8);
  height: 30px;
  border-radius: 10px;
  color: firebrick;
 
}

/*@GOOGLE*/
.material-symbols-outlined {
  cursor: pointer;
  font-variation-settings:
  'FILL' 0,
  'wght' 400,
  'GRAD' 0,
  'opsz' 24
}

.btn-google {

  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}

.md-24 {

  font-size: 24px;

}

.md-25 {

  font-size: 24px;

}

.md-36 {

  font-size: 36px;

}

.md-48 {

  font-size: 48px;

}

/*@GOOGLE*/


.no-scroll {

  width: 100%;
 
}

.home {

  height: 100vh;
  width: 100%;

}

.viewport {
  overflow: auto;

  /* Make sure the inner div is not larger than the container
   * so that we have room to scroll.
   */
  max-height: 100%;

  /* Pick an arbitrary margin/padding that should be bigger
   * than the max width of all the scroll bars across
   * the devices you are targeting.
   * padding = -margin
   */

}

.menu{

  position: fixed;
  width: 60px;
  height: 60px;
  background: whitesmoke;


}

.hamburger {

  position: fixed;
  background-color: white;
  top: 20px;
  right: 40px;
  text-align: center;
  display: block;
  cursor: pointer;
  box-shadow: 5px 5px 5px 0px  rgba(190, 169, 169, 0.75);
  transition: all 1s ease;
  z-index: 1000;
}

.hamburger div {

  width: 25px;
  height: 3px;
  background-color: black;
  margin: 5px;
  transition: all 0.3s ease;
}

.toggle1 {

  transform: rotate(-45deg)  translate(-5px, 6px); 

}

.toggle2 {

  opacity: 0;

}

.toggle3 {

  transform: rotate(45deg) translate(-5px, -6px);
  
}

.pizarra  {

  margin-left: 2%;
  width: 96%;
  justify-self: center;
  margin-top: 80px;
  display: inline-block;
  align-items: center;

}

.items {

  width: 100%;
  /*position: absolute;
  top:50%;
  left: 50%;*/
  /* background-color: darkblue; */
  /* transform:  translate(-50%,-50%); */
  display: flex;
  align-items: center;
  justify-content:center;
  padding-left: 20px;
  padding-right: 20px; 
  font-family: 'Poppins', Verdana, Geneva, Tahoma, sans-serif;
  font-weight: 600;
  font-size: 17px;

}


.saludo {

  font-family: 'Poppins', sans-serif;
  font-size: 35px;
  font-weight:600;
  margin-left: 20px;
  margin-bottom: 15px;
  color: orange;


}

.usuarios {

  background-image: linear-gradient(to right, gray, black);

}

h1 {

  font-family: 'Poppins', sans-serif;
  font-size: 15px;
  font-weight:900;
  margin-top: 15px;
  letter-spacing: 2px;


}

.ventas {

  /* color: #4572d9; */
  /* transition: all 10s ease-in-out; */
  animation: run 0.5s forwards;
  animation-delay: 0.5s;
 

}

.compras {

 /* color: #40a4de; */
  /* transition: all 10s ease-in-out; */
  animation: run 1.5s forwards;
  animation-delay: 1s;
 

}


.inventarios {

  
  /* transition: all 10s ease-in-out; */
  animation: run 2.5s forwards;
  animation-delay: 1.5s;
 

}


.usuarios, .ventas, .compras, .inventarios {


  display: inline-block;
  width: 32%;
  margin-left: 5px;
  margin-top: 7px;
  margin-right: 7px;
  color: #4682b4;
  height: 250px;
  text-align: center;
  border-radius: 10px;
  box-shadow: 5px 5px 5px 0px  rgba(190, 169, 169, 0.75);
  overflow: hidden;
  /* overflow-y: auto; */
  transition: all 1s ease;
  opacity: 0;  
  

}


.contenedor-izquierdo {

    float: left;
    position: fixed;
    width: 250px;
    /* margin-top: 60px; */
    overflow-y:auto;
    height: 100vh;

}


.contenedor-derecho {

  /* margin-top: 60px; */
  /* float: right; */
  margin-right: 0px;
  margin-left:   0px;
  position: relative;
  width: 100%;
  height: 100vh;
  overflow-y: scroll;
  overflow-x: auto;
}

.footer {

  position: absolute;
  bottom: 0px;
  width: 100%;
  background-color: whitesmoke;
  height: 50px;

}

.fondoazul {

  background-color: #5DBCD2;

}

.sunset_menu {

  margin-top: 5px;
  margin-left: 15px;
  margin-bottom: 5px;
  z-index: 999;
  cursor: pointer;
  height: 50px;
  width: 50px;

}


.barra{

  background-color: white;
  height: 50px;
  width: 50px;
  border-radius: 100%;
  
  justify-content: center;
  align-items: center;
  border: 15px rgba(0, 0, 0, 0.7);

}


img {

  width: 100%;

}

.mostrar {

  width: 80vw;
  height: 100%;
  top: 0px;
  right: 0px;
  background-color: rgba(0,0,0,0.8);
  position: fixed;
  z-index: 3;
  overflow-x: hidden;
  overflow-y: auto;
 }

 .seleccion {


  position: fixed;
  background-size: cover;
  top:0px;
  left: 0px;
  width: 100%;
  min-width: 400px;
  height: 100%;
  background-color: transparent;

}

.salir
 {
    color: white;
    position: fixed;
    top: 20px;
    right: 40px;
    z-index: 4;
    
 }

 .salir span {

    font-size: 30px;

 }

 .salir:hover {

    cursor: pointer;

 }


 #btnMenu {

  width: 50px;
  position: fixed;
  top: 20px;
  right: 20px;
  z-index: 2;
  cursor: pointer;
  
 }


 @keyframes run {

    0% {opacity: 0;}

    50% {opacity: 0.5;}

   
    100% { opacity: 1; }
}


@media(max-width:938px) {

  .contenedor-izquierdo {


   display: none;

}

.mostrar {

  width: 100vw;
 }

.usuarios, .ventas, .compras, .inventarios {

  min-width: 48%;
  margin-top: 15px;
 
}


.seleccion {


  position: fixed;
  background-size: cover;
  top:0px;
  right: 0px;
  width: 100%;
  height: 100%;

}


.contenedor-derecho {

  margin-left:  0%;
  position: fixed;
  height: 100vh;
  width: 100%;

  padding-bottom: 15px;

}



}


@media(max-width:768px) {


.pizarra {

  width: 94%;
  margin-right: 4%;
 
}

.usuarios, .ventas, .compras, .inventarios {

  width: 96%;
  min-width:400px;
  margin-top: 15px;
 
}

.items  {
  width: 100%;
  height: 100%;
}

}`, "",{"version":3,"sources":["webpack://./src/app/components/home/home.component.css"],"names":[],"mappings":"AAEA;;EAEE,yCAAyC;EACzC,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;;AAElB;;AAEA,UAAU;AACV;EACE,eAAe;EACf;;;;;AAKF;;AAEA;;EAEE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;;EAEE,eAAe;;AAEjB;;AAEA;;EAEE,eAAe;;AAEjB;;AAEA;;EAEE,eAAe;;AAEjB;;AAEA;;EAEE,eAAe;;AAEjB;;AAEA,UAAU;;;AAGV;;EAEE,WAAW;;AAEb;;AAEA;;EAEE,aAAa;EACb,WAAW;;AAEb;;AAEA;EACE,cAAc;;EAEd;;IAEE;EACF,gBAAgB;;EAEhB;;;;IAIE;;AAEJ;;AAEA;;EAEE,eAAe;EACf,WAAW;EACX,YAAY;EACZ,sBAAsB;;;AAGxB;;AAEA;;EAEE,eAAe;EACf,uBAAuB;EACvB,SAAS;EACT,WAAW;EACX,kBAAkB;EAClB,cAAc;EACd,eAAe;EAGf,sDAAsD;EACtD,uBAAuB;EACvB,aAAa;AACf;;AAEA;;EAEE,WAAW;EACX,WAAW;EACX,uBAAuB;EACvB,WAAW;EACX,yBAAyB;AAC3B;;AAEA;;EAEE,+CAA+C;;AAEjD;;AAEA;;EAEE,UAAU;;AAEZ;;AAEA;;EAEE,8CAA8C;;AAEhD;;AAEA;;EAEE,eAAe;EACf,UAAU;EACV,oBAAoB;EACpB,gBAAgB;EAChB,qBAAqB;EACrB,mBAAmB;;AAErB;;AAEA;;EAEE,WAAW;EACX;;aAEW;EACX,gCAAgC;EAChC,sCAAsC;EACtC,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;EAClB,mBAAmB;EACnB,2DAA2D;EAC3D,gBAAgB;EAChB,eAAe;;AAEjB;;;AAGA;;EAEE,kCAAkC;EAClC,eAAe;EACf,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;;;AAGf;;AAEA;;EAEE,wDAAwD;;AAE1D;;AAEA;;EAEE,kCAAkC;EAClC,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,mBAAmB;;;AAGrB;;AAEA;;EAEE,oBAAoB;EACpB,qCAAqC;EACrC,4BAA4B;EAC5B,qBAAqB;;;AAGvB;;AAEA;;CAEC,oBAAoB;EACnB,qCAAqC;EACrC,4BAA4B;EAC5B,mBAAmB;;;AAGrB;;;AAGA;;;EAGE,qCAAqC;EACrC,4BAA4B;EAC5B,qBAAqB;;;AAGvB;;;AAGA;;;EAGE,qBAAqB;EACrB,UAAU;EACV,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EAGnB,sDAAsD;EACtD,gBAAgB;EAChB,sBAAsB;EACtB,uBAAuB;EACvB,UAAU;;;AAGZ;;;AAGA;;IAEI,WAAW;IACX,eAAe;IACf,YAAY;IACZ,sBAAsB;IACtB,eAAe;IACf,aAAa;;AAEjB;;;AAGA;;EAEE,sBAAsB;EACtB,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;;EAEE,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,4BAA4B;EAC5B,YAAY;;AAEd;;AAEA;;EAEE,yBAAyB;;AAE3B;;AAEA;;EAEE,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,YAAY;EACZ,WAAW;;AAEb;;;AAGA;;EAEE,uBAAuB;EACvB,YAAY;EACZ,WAAW;EACX,mBAAmB;;EAEnB,uBAAuB;EACvB,mBAAmB;EACnB,+BAA+B;;AAEjC;;;AAGA;;EAEE,WAAW;;AAEb;;AAEA;;EAEE,WAAW;EACX,YAAY;EACZ,QAAQ;EACR,UAAU;EACV,iCAAiC;EACjC,eAAe;EACf,UAAU;EACV,kBAAkB;EAClB,gBAAgB;CACjB;;CAEA;;;EAGC,eAAe;EACf,sBAAsB;EACtB,OAAO;EACP,SAAS;EACT,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,6BAA6B;;AAE/B;;AAEA;;IAEI,YAAY;IACZ,eAAe;IACf,SAAS;IACT,WAAW;IACX,UAAU;;CAEb;;CAEA;;IAEG,eAAe;;CAElB;;CAEA;;IAEG,eAAe;;CAElB;;;CAGA;;EAEC,WAAW;EACX,eAAe;EACf,SAAS;EACT,WAAW;EACX,UAAU;EACV,eAAe;;CAEhB;;;CAGA;;IAEG,IAAI,UAAU,CAAC;;IAEf,KAAK,YAAY,CAAC;;;IAGlB,OAAO,UAAU,EAAE;AACvB;;;AAGA;;EAEE;;;GAGC,aAAa;;AAEhB;;AAEA;;EAEE,YAAY;CACb;;AAED;;EAEE,cAAc;EACd,gBAAgB;;AAElB;;;AAGA;;;EAGE,eAAe;EACf,sBAAsB;EACtB,OAAO;EACP,UAAU;EACV,WAAW;EACX,YAAY;;AAEd;;;AAGA;;EAEE,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,WAAW;;EAEX,oBAAoB;;AAEtB;;;;AAIA;;;AAGA;;;AAGA;;EAEE,UAAU;EACV,gBAAgB;;AAElB;;AAEA;;EAEE,UAAU;EACV,eAAe;EACf,gBAAgB;;AAElB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Poppins&display=swap');\r\n\r\nngb-alert {\r\n\r\n  background-color: rgba(226, 214, 37, 0.8);\r\n  height: 30px;\r\n  border-radius: 10px;\r\n  color: firebrick;\r\n \r\n}\r\n\r\n/*@GOOGLE*/\r\n.material-symbols-outlined {\r\n  cursor: pointer;\r\n  font-variation-settings:\r\n  'FILL' 0,\r\n  'wght' 400,\r\n  'GRAD' 0,\r\n  'opsz' 24\r\n}\r\n\r\n.btn-google {\r\n\r\n  display: flex;\r\n  flex-direction: row;\r\n  justify-content: center;\r\n  align-items: center;\r\n}\r\n\r\n.md-24 {\r\n\r\n  font-size: 24px;\r\n\r\n}\r\n\r\n.md-25 {\r\n\r\n  font-size: 24px;\r\n\r\n}\r\n\r\n.md-36 {\r\n\r\n  font-size: 36px;\r\n\r\n}\r\n\r\n.md-48 {\r\n\r\n  font-size: 48px;\r\n\r\n}\r\n\r\n/*@GOOGLE*/\r\n\r\n\r\n.no-scroll {\r\n\r\n  width: 100%;\r\n \r\n}\r\n\r\n.home {\r\n\r\n  height: 100vh;\r\n  width: 100%;\r\n\r\n}\r\n\r\n.viewport {\r\n  overflow: auto;\r\n\r\n  /* Make sure the inner div is not larger than the container\r\n   * so that we have room to scroll.\r\n   */\r\n  max-height: 100%;\r\n\r\n  /* Pick an arbitrary margin/padding that should be bigger\r\n   * than the max width of all the scroll bars across\r\n   * the devices you are targeting.\r\n   * padding = -margin\r\n   */\r\n\r\n}\r\n\r\n.menu{\r\n\r\n  position: fixed;\r\n  width: 60px;\r\n  height: 60px;\r\n  background: whitesmoke;\r\n\r\n\r\n}\r\n\r\n.hamburger {\r\n\r\n  position: fixed;\r\n  background-color: white;\r\n  top: 20px;\r\n  right: 40px;\r\n  text-align: center;\r\n  display: block;\r\n  cursor: pointer;\r\n  -webkit-box-shadow: 5px 5px 5px 0px rgba(190, 169, 169, 0.75);\r\n  -moz-box-shadow: 5px 5px 5px 0px  rgba(190, 169, 169, 0.75);\r\n  box-shadow: 5px 5px 5px 0px  rgba(190, 169, 169, 0.75);\r\n  transition: all 1s ease;\r\n  z-index: 1000;\r\n}\r\n\r\n.hamburger div {\r\n\r\n  width: 25px;\r\n  height: 3px;\r\n  background-color: black;\r\n  margin: 5px;\r\n  transition: all 0.3s ease;\r\n}\r\n\r\n.toggle1 {\r\n\r\n  transform: rotate(-45deg)  translate(-5px, 6px); \r\n\r\n}\r\n\r\n.toggle2 {\r\n\r\n  opacity: 0;\r\n\r\n}\r\n\r\n.toggle3 {\r\n\r\n  transform: rotate(45deg) translate(-5px, -6px);\r\n  \r\n}\r\n\r\n.pizarra  {\r\n\r\n  margin-left: 2%;\r\n  width: 96%;\r\n  justify-self: center;\r\n  margin-top: 80px;\r\n  display: inline-block;\r\n  align-items: center;\r\n\r\n}\r\n\r\n.items {\r\n\r\n  width: 100%;\r\n  /*position: absolute;\r\n  top:50%;\r\n  left: 50%;*/\r\n  /* background-color: darkblue; */\r\n  /* transform:  translate(-50%,-50%); */\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content:center;\r\n  padding-left: 20px;\r\n  padding-right: 20px; \r\n  font-family: 'Poppins', Verdana, Geneva, Tahoma, sans-serif;\r\n  font-weight: 600;\r\n  font-size: 17px;\r\n\r\n}\r\n\r\n\r\n.saludo {\r\n\r\n  font-family: 'Poppins', sans-serif;\r\n  font-size: 35px;\r\n  font-weight:600;\r\n  margin-left: 20px;\r\n  margin-bottom: 15px;\r\n  color: orange;\r\n\r\n\r\n}\r\n\r\n.usuarios {\r\n\r\n  background-image: linear-gradient(to right, gray, black);\r\n\r\n}\r\n\r\nh1 {\r\n\r\n  font-family: 'Poppins', sans-serif;\r\n  font-size: 15px;\r\n  font-weight:900;\r\n  margin-top: 15px;\r\n  letter-spacing: 2px;\r\n\r\n\r\n}\r\n\r\n.ventas {\r\n\r\n  /* color: #4572d9; */\r\n  /* transition: all 10s ease-in-out; */\r\n  animation: run 0.5s forwards;\r\n  animation-delay: 0.5s;\r\n \r\n\r\n}\r\n\r\n.compras {\r\n\r\n /* color: #40a4de; */\r\n  /* transition: all 10s ease-in-out; */\r\n  animation: run 1.5s forwards;\r\n  animation-delay: 1s;\r\n \r\n\r\n}\r\n\r\n\r\n.inventarios {\r\n\r\n  \r\n  /* transition: all 10s ease-in-out; */\r\n  animation: run 2.5s forwards;\r\n  animation-delay: 1.5s;\r\n \r\n\r\n}\r\n\r\n\r\n.usuarios, .ventas, .compras, .inventarios {\r\n\r\n\r\n  display: inline-block;\r\n  width: 32%;\r\n  margin-left: 5px;\r\n  margin-top: 7px;\r\n  margin-right: 7px;\r\n  color: #4682b4;\r\n  height: 250px;\r\n  text-align: center;\r\n  border-radius: 10px;\r\n  -webkit-box-shadow: 5px 5px 5px 0px rgba(190, 169, 169, 0.75);\r\n  -moz-box-shadow: 5px 5px 5px 0px  rgba(190, 169, 169, 0.75);\r\n  box-shadow: 5px 5px 5px 0px  rgba(190, 169, 169, 0.75);\r\n  overflow: hidden;\r\n  /* overflow-y: auto; */\r\n  transition: all 1s ease;\r\n  opacity: 0;  \r\n  \r\n\r\n}\r\n\r\n\r\n.contenedor-izquierdo {\r\n\r\n    float: left;\r\n    position: fixed;\r\n    width: 250px;\r\n    /* margin-top: 60px; */\r\n    overflow-y:auto;\r\n    height: 100vh;\r\n\r\n}\r\n\r\n\r\n.contenedor-derecho {\r\n\r\n  /* margin-top: 60px; */\r\n  /* float: right; */\r\n  margin-right: 0px;\r\n  margin-left:   0px;\r\n  position: relative;\r\n  width: 100%;\r\n  height: 100vh;\r\n  overflow-y: scroll;\r\n  overflow-x: auto;\r\n}\r\n\r\n.footer {\r\n\r\n  position: absolute;\r\n  bottom: 0px;\r\n  width: 100%;\r\n  background-color: whitesmoke;\r\n  height: 50px;\r\n\r\n}\r\n\r\n.fondoazul {\r\n\r\n  background-color: #5DBCD2;\r\n\r\n}\r\n\r\n.sunset_menu {\r\n\r\n  margin-top: 5px;\r\n  margin-left: 15px;\r\n  margin-bottom: 5px;\r\n  z-index: 999;\r\n  cursor: pointer;\r\n  height: 50px;\r\n  width: 50px;\r\n\r\n}\r\n\r\n\r\n.barra{\r\n\r\n  background-color: white;\r\n  height: 50px;\r\n  width: 50px;\r\n  border-radius: 100%;\r\n  \r\n  justify-content: center;\r\n  align-items: center;\r\n  border: 15px rgba(0, 0, 0, 0.7);\r\n\r\n}\r\n\r\n\r\nimg {\r\n\r\n  width: 100%;\r\n\r\n}\r\n\r\n.mostrar {\r\n\r\n  width: 80vw;\r\n  height: 100%;\r\n  top: 0px;\r\n  right: 0px;\r\n  background-color: rgba(0,0,0,0.8);\r\n  position: fixed;\r\n  z-index: 3;\r\n  overflow-x: hidden;\r\n  overflow-y: auto;\r\n }\r\n\r\n .seleccion {\r\n\r\n\r\n  position: fixed;\r\n  background-size: cover;\r\n  top:0px;\r\n  left: 0px;\r\n  width: 100%;\r\n  min-width: 400px;\r\n  height: 100%;\r\n  background-color: transparent;\r\n\r\n}\r\n\r\n.salir\r\n {\r\n    color: white;\r\n    position: fixed;\r\n    top: 20px;\r\n    right: 40px;\r\n    z-index: 4;\r\n    \r\n }\r\n\r\n .salir span {\r\n\r\n    font-size: 30px;\r\n\r\n }\r\n\r\n .salir:hover {\r\n\r\n    cursor: pointer;\r\n\r\n }\r\n\r\n\r\n #btnMenu {\r\n\r\n  width: 50px;\r\n  position: fixed;\r\n  top: 20px;\r\n  right: 20px;\r\n  z-index: 2;\r\n  cursor: pointer;\r\n  \r\n }\r\n\r\n\r\n @keyframes run {\r\n\r\n    0% {opacity: 0;}\r\n\r\n    50% {opacity: 0.5;}\r\n\r\n   \r\n    100% { opacity: 1; }\r\n}\r\n\r\n\r\n@media(max-width:938px) {\r\n\r\n  .contenedor-izquierdo {\r\n\r\n\r\n   display: none;\r\n\r\n}\r\n\r\n.mostrar {\r\n\r\n  width: 100vw;\r\n }\r\n\r\n.usuarios, .ventas, .compras, .inventarios {\r\n\r\n  min-width: 48%;\r\n  margin-top: 15px;\r\n \r\n}\r\n\r\n\r\n.seleccion {\r\n\r\n\r\n  position: fixed;\r\n  background-size: cover;\r\n  top:0px;\r\n  right: 0px;\r\n  width: 100%;\r\n  height: 100%;\r\n\r\n}\r\n\r\n\r\n.contenedor-derecho {\r\n\r\n  margin-left:  0%;\r\n  position: fixed;\r\n  height: 100vh;\r\n  width: 100%;\r\n\r\n  padding-bottom: 15px;\r\n\r\n}\r\n\r\n\r\n\r\n}\r\n\r\n\r\n@media(max-width:768px) {\r\n\r\n\r\n.pizarra {\r\n\r\n  width: 94%;\r\n  margin-right: 4%;\r\n \r\n}\r\n\r\n.usuarios, .ventas, .compras, .inventarios {\r\n\r\n  width: 96%;\r\n  min-width:400px;\r\n  margin-top: 15px;\r\n \r\n}\r\n\r\n.items  {\r\n  width: 100%;\r\n  height: 100%;\r\n}\r\n\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
